// extracted by mini-css-extract-plugin
export default {"container":"CreateDog_container__-kEJm"};